/* global axios */
import { msBaseUrl } from './microservicos';

export const attendancePricesAPI = {
  getAll(accountId) {
    return axios.get(`${msBaseUrl('crm', accountId)}/attendance-prices`);
  },

  // The screen is a grid, so it saves every cell in one request. A cell sent with
  // priceValue null clears that specialty × attendance type combination.
  saveAll(accountId, items) {
    return axios.put(`${msBaseUrl('crm', accountId)}/attendance-prices`, items);
  },
};
